const config = {
  auth0: {
    domain: process.env.REACT_APP_AUTH0_DOMAIN || '@@REACT_APP_AUTH0_DOMAIN@@',
    clientID: process.env.REACT_APP_AUTH0_CLIENT_ID || '@@REACT_APP_AUTH0_CLIENT_ID@@',
    redirectURI: process.env.REACT_APP_AUTH0_REDIRECT_URI || '@@REACT_APP_AUTH0_REDIRECT_URI@@',
    audience: process.env.REACT_APP_AUTH0_AUDIENCE || '@@REACT_APP_AUTH0_AUDIENCE@@'
  },
  api: {
    storesBffUrl: process.env.REACT_APP_STORES_BFF_URL || '@@REACT_APP_STORES_BFF_URL@@',
    rewardsHandlerUrl: process.env.REACT_APP_REWARDS_HANDLER_URL || '@@REACT_APP_REWARDS_HANDLER_URL@@',
    auth0RedirectUri: process.env.REACT_APP_AUTH0_REDIRECT_URI || '@@REACT_APP_AUTH0_REDIRECT_URI@@',
    promoBffUrl: process.env.REACT_APP_PROMO_BFF_URL || '@@REACT_APP_PROMO_BFF_URL@@'
  },
  environment: process.env.REACT_APP_ENVIRONMENT || '@@REACT_APP_ENVIRONMENT@@',
  amplitude: process.env.REACT_APP_AMPLITUDE_API_KEY || '@@REACT_APP_AMPLITUDE_API_KEY@@'
};

export default config;
